/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  app.ChosenFiltersPopupView = app.View.extend({
    events: {
      'click .but-apply': 'applyFilters',
      'click .reset-filters': 'resetFilters',
      'change .scrollable input[type=checkbox]': 'handleCheckboxChange',
      'change .fromTo__input': 'handleRangeChange',
    },
    // data-id опции "Неважно"
    emptySelectValue: 9999,
    additionalOptions: ['rowView', 'filtersView', 'filters'],
    SLIDER_STEP: 1,
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#filters-row-popup-template');
      this.checkboxListTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-checkbox-list-template');
      this.rangeFilterTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-range-filter-template');
      this.selectFilterTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-select-filter-template');
      this.listenTo(this.rowView, 'choose-section', this.togglePopupActive);
      this.listenTo(Backbone, 'bodyView:click', this.bodyClick);
    },
    /**
     * Применяет выбранные в попапе фильтры.
     * @param e
     */
    applyFilters: function (e) {
      this.hidePopup(true);
      this.filters.updateChosenFilters(this.model);
      this.trigger('update-filter', e);
    },
    /**
     * Сбрасывает выбранные значения в фильтре, открытом в попапе
     * @param e
     */
    resetFilters: function (e) {
      var filterObj = this.rowView.getFilterObj();
      delete filterObj[this.sectionName];
      this.trigger('update-filter', e, filterObj);
    },
    /**
     * Меняет состояние активности попапа.
     * @param e
     * @param toggle
     */
    togglePopupActive: function (e, toggle) {
      var target = $(e.currentTarget);

      if (toggle) {
        this.$el.toggleClass('not_display');
      } else {
        this.$el.removeClass('not_display');
        this.render();
        this.$el.css({left: target.position().left});
        this.listenTo(this.model, 'reset', this.render);
        Backbone.trigger('chosen-popup-active', true, this.sectionName);
      }

      if (this.$el.hasClass('not_display')) {
        this.hidePopup(true);
      }
    },
    /**
     * Скрывает попап
     * @param resetSectionName нужно ли сбрасывать название секции
     */
    hidePopup: function (resetSectionName) {
      if (resetSectionName) {
        this.sectionName = undefined;
      }
      Backbone.trigger('chosen-popup-active', false, this.sectionName);
      this.$el.addClass('not_display');
      this.$('.scrollable').html('');
      this.stopListening(this.model, 'reset', this.render);
      if (this.childViews.selectView) {
        this.stopListening(this.childViews.selectView.model, 'change:selected', this.handleSelect);
      }
    },
    /**
     * @inheritDoc
     * @returns {app.ChosenFiltersPopupView}
     */
    render: function () {
      var model = this.model.findWhere({paramName: this.sectionName});
      if (model) {
        var type = model.get('class_name');
        switch (type) {
          case 'ColoredCheckboxList':
          case 'HasOne':
          case 'HasMany':
          case 'AggMinQty':
          case 'AggSupplyPeriod':
          case 'Specification':
            this.renderListFilter(model, this.sectionName);
            break;
          case 'Range':
          case 'AggRange':
            this.renderRangeFilter(model, this.sectionName);
            break;
          case 'CheckboxDropDown':
          case 'DropDown':
            this.renderDropDownFilter(model, this.sectionName);
            break;
          default:
            this.hidePopup(true);
        }
      } else {
        this.hidePopup(true);
      }
      return this;
    },
    /**
     * Рисует попап
     * @param html разметка фильтра
     * @param name название секции
     */
    renderPopup: function (html, name) {
      this.$el.html(this.template({
        filters: html,
        total: this.filters.filtered,
        section: name,
      }));
    },
    /**
     * Рисует фильтр-список чекбоксов
     * @param model модель фильтра
     * @param name название секции
     */
    renderListFilter: function (model, name) {
      var that = this;
      var values = this.moveSelectedValuesToTop(model.get('values'));
      var totalSelected = model.get('selectedQty');
      var html = values.reduce(function (acc, cur, index) {
        var color = cur.option_color;
        if (color) {
          if (color[0] === '#') {
            cur.style_color = color;
          } else {
            cur.icon_name = color;
          }
        }
        acc += that.checkboxListTemplate({
          object: cur,
          last: index === totalSelected - 1,
          className: model.get('class_name'),
          icon_name: cur.icon_name,
          style_color: cur.style_color,
          sectionName: name,
        });
        return acc;
      }, '');
      this.renderPopup(html, name);
    },
    /**
     * Переносит выбранные значения фильтра наверх.
     * @param values
     * @return Отсортированные значения
     */
    moveSelectedValuesToTop: function (values) {
      return _.sortBy(values, function(value) {
        return !value.selected;
      });
    },
    /**
     * Рисует фильтр по диапазону
     * @param model
     * @param name
     */
    renderRangeFilter: function (model, name) {
      var values = model.get('values');
      var that = this;
      var html = this.rangeFilterTemplate({
        values: values,
        sign: model.get('sign'),
        name: name,
        unit_name: model.get('unit_name'),
      });
      var slider_step = model.get('slider_step') ? model.get('slider_step') : that.SLIDER_STEP;
      this.renderPopup(html, name);
      var min = this.$('.filter-range-begin-input');
      var max = this.$('.filter-range-end-input');
      this.$('.slider_div').slider({
        range: true,
        step: slider_step,
        min: values.min.value,
        max: values.max.value,
        values: [values.min.selected, values.max.selected],
        slide: function (event, ui) {
          var newMin = app.helpers.NumberHelper.addSpaceToFloatNumber(ui.values[0]);
          var newMax = app.helpers.NumberHelper.addSpaceToFloatNumber(ui.values[1]);
          min.val(newMin).attr('size', newMin.length);
          max.val(newMax).attr('size', newMax.length);
        },
        stop: function (event, ui) {
          that.handleRangeChange(event, ui.values, name);
        },
      });
    },
    /**
     * Рисует фильтр-селект
     * @param model
     * @param name
     */
    renderDropDownFilter: function (model, name) {
      var selectedOption = _.find(model.get('values'), {selected: true});
      var title = model.get('name');
      var value = selectedOption ? selectedOption.name : 'Неважно';
      var selected = selectedOption ? selectedOption.id : null;
      var html = this.selectFilterTemplate({
        title: title,
        name: name,
        value: value,
      });
      this.renderPopup(html, name);
      model.set('selected', selected);
      this.childViews.selectView = new app.SelectView({
        model: model,
        el: this.$('.filter-select-field'),
        field: 'selected',
        inputSelector: '.select-input',
        optionsSelector: '.filter-select',
        optionsTemplateName: '#filters-row-select-template',
      });

      this.childViews.selectView.render(value);
      this.listenTo(this.childViews.selectView.model, 'change:selected', this.handleSelect);
    },
    /**
     * Обрабатывает изменение фильтра по диапазону
     * @param e
     * @param values
     * @param section
     *
     * @returns {Object} filterObj объект с фильтрами для применения
     */
    handleRangeChange: function (e, values, section) {
      // если поменяли прямо в инпуте
      if (e.type === 'change') {
        var min = this.$('.filter-range-begin-input').val();
        var max = this.$('.filter-range-end-input').val();
        section = this.$('[data-section]').data('section');
        values = [this.parseValue(min), this.parseValue(max)];
        this.$('.slider_div').slider('values', values);
        values = this.$('.slider_div').slider('values');
      }
      var filterObj = this.rowView.getFilterObj();
      filterObj[section] = values;
      this.trigger('update-filter', e, filterObj);

      return filterObj;
    },
    /**
     * Обрабатывает изменение фильтра-списка чекбоксов
     * @param e
     *
     * @returns {Object} filterObj объект с фильтрами для применения
     */
    handleCheckboxChange: function (e) {
      var target = $(e.currentTarget);
      var id = target.attr('data-id');
      var section = target.data('section').replace(/spec-\d/, '');
      var currentFilterObj = this.rowView.getFilterObj();
      var filterObj = {};
      if (target.prop('checked')) {
        filterObj[section] = [id];
        filterObj = app.helpers.ObjectHelper.mergeDeep(currentFilterObj, filterObj);
      } else {
        filterObj = currentFilterObj;
        filterObj[section] = filterObj[section].filter(function (val) {
          return String(val) !== String(id);
        });
      }
      this.trigger('update-filter', e, filterObj);

      return filterObj;
    },
    /**
     * Обрабатывает изменение фильтра-селекта
     * @param model
     * @param value
     *
     * @returns {Object} filterObj объект с фильтрами для применения
     */
    handleSelect: function (model, value) {
      var filterObj = this.rowView.getFilterObj();
      var section = model.get('paramName');
      this.childViews.selectView.hidePopup();
      if (value === this.emptySelectValue) {
        delete filterObj[section];
      } else {
        filterObj[section] = [value];
      }
      this.trigger('update-filter', new Event({type: 'change'}), filterObj);

      return filterObj;
    },
    /**
     * Обрабатывает клик за пределами попапа
     * @param e
     */
    bodyClick: function (e) {
      var closed = this.$el.hasClass('not_display');
      if (!closed) {
        var insidePopup = $(e.target).closest('.chosen-filters-popup').length;
        var filterFlagClicked = $(e.target).closest('.filter-flag').length;
        if (!(insidePopup || filterFlagClicked)) {
          this.trigger('remove-active-flag');
          this.hidePopup(true);
        }
      }
    },

    /**
     * Убирает из строки все кроме чисел и точки.
     * @param value    Значение
     * @returns {*}
     */
    parseValue: function (value) {
      if (typeof value !== 'number') {
        value = value.replace(/[^\d.,]/g, '').replace(',', '.');
      }
      return value;
    },
  });
})();

}.call(window));